import { Box, Button } from '@factorialco/deprecated-design-system'

interface ActionsProps {
  journalEntryId: number
  onClickDetail: (journalEntryId: number) => void
}

const Actions = ({ journalEntryId, onClickDetail }: ActionsProps) => {
  return (
    <Box gap="s4" flexDirection="row" justifyContent="flexEnd">
      <Button
        type="secondary"
        onClick={() => onClickDetail(journalEntryId)}
        iconName="arrow-right"
      />
    </Box>
  )
}

export default Actions
